<template>
  <h1 class="text-center">Survery Test Page</h1>
</template>

<script>
export default {
  mounted() {
    window.survser("triggerSurvey", "survser-default-demo");
  },
};
</script>
